import React, { useMemo } from 'react'

import bemit from '@function/bemit'

import { user_status } from '@Config/options'

import { num, isTrue, formatNum } from '@root/utility'

export default function ECUserAbondementRow ({ member, abondement, ...props })
{
	const modifiers = useMemo(function ()
	{
		const modifiers = [].concat(props.selected ? ['selected'] : []);

		return modifiers;
	},
	[props.selected]);

	const catalog_used = useMemo(function ()
	{
		return (abondement?.catalog_used || []).reduce(function (total, data)
		{
			return num(total + num(data.amount));
		},
		0);
	},
	[abondement]);

	const attributed = useMemo(function ()
	{
		return (abondement?.history || []).reduce(function (total, data)
		{
			return num(total + num(data.difference));
		},
		0);
	},
	[abondement]);

	const status_option = user_status
	.find(opt => opt.value === member.validation_status);

	const status_color = status_option?.color || 'primary';

	return (
		<div className={ bemit('c-user-abondement-row', modifiers) }>

			<div className="c-user-abondement-row__cell UserAbondement-cb">
				<div className="c-form-element c-form-element--checkbox">
					<input className="c-form__checkbox" name={ member.id }
						onChange={ props.onMemberSelection }
						id={ 'user_checked-' + member.id } type="checkbox"
						checked={ isTrue(props.selected) }
					/>
					<label className="c-form__checkbox-indicator"
						htmlFor={ 'user_checked-' + member.id }
					/>
				</div>

			</div>

			<div className="c-user-abondement-row__cell UserAbondement-name">
				{ member.lastname }
				{ ' ' }
				{ member.firstname }
			</div>

			<div className="c-user-abondement-row__cell UserAbondement-status">
				<div className={ bemit('c-status', [status_color]) }>
					{ status_option?.label }
				</div>
			</div>

			<div className="c-user-abondement-row__cell UserAbondement-attributed">
				{ formatNum(attributed, '0.0[.]00') }
			</div>

			<div className="c-user-abondement-row__cell UserAbondement-used">
				{ formatNum(abondement?.used, '0.0[.]00') }
			</div>

			<div className="c-user-abondement-row__cell UserAbondement-value">
				{ formatNum(abondement?.value, '0.0[.]00') }
			</div>

			<div className="c-user-abondement-row__cell UserAbondement-catalog_used">
				{ formatNum(catalog_used, '0.0[.]00') }
			</div>

		</div>
	);
}